<template>
  <div class="ClientHeader">

    <div class="ClientHeader-header">

      <icon class="ClientHeader-lockIcon"
        v-if="breadcrumbs"
        :class="{ 'ClientHeader-lockIcon--isLarge': breadcrumbs[0].large }"
        name="lock"
        :width="breadcrumbs[0].large ? '18px' : '11px'"
        :height="breadcrumbs[0].large ? '18px' : '11px'" />

      <breadcrumbs class="ClientHeader-breadcrumbs"
        :items="breadcrumbs" />

    </div>

    <template v-if="description">

      <break size="0.5" />

      <markdown class="c-grey-md-lt"
        v-if="description"
        :content="description" />

    </template>

    <break size="2" />

  </div>
</template>

<script>
export default {
  name: 'ClientHeader',

  props: {
    breadcrumbs: {
      type: Array
    },
    description: {
      type: String
    }
  }
}
</script>

<style>
@import 'properties';

.ClientHeader {

}

.ClientHeader-header {
  /*display: flex;*/
  /*align-items: center;*/
}

.ClientHeader-lockIcon {
display: none;
  position: relative;
  top: -2px;
  margin-right: var(--unit-025);
}

.ClientHeader-lockIcon--isLarge {
  margin-right: var(--unit-05);
}

.ClientHeader-lockIcon svg {
  fill: var(--c-grey-lt) !important;
}
</style>



// WEBPACK FOOTER //
// ClientHeader.vue?ef395e02